/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import L from "../Lang";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class DataView extends BaseCom {

    async componentDidMount() {
        await this.fillDataAsync();

        if(this.props.dict) this.setState({ columns: this.props.dict });
        if(this.props.list) this.setState({ list: this.props.list });
    }

    async componentDidUpdate(prevProps) {
        if (this.props.hash !== prevProps.hash)
            await this.fillDataAsync();
        if (this.props.dict !== prevProps.dict)
            this.setState({ columns: this.props.dict});
        if (this.props.list !== prevProps.list)
            this.setState({ list: this.props.list });
    }

    async fillDataAsync() {
        if(!this.props.api) return;
        try {
            let j = await qreq.getAsync(this.props.api);
            if (j.errorCode === 0) {
                this.setState({ list: j.list, columns: j.dict });
            }
            else
                this.alert(j.errorMessage);
        }
        catch {
            this.unkownErrorCallback();
        }
    }


    rowClick = (row) => {
        if (this.props.rowLink) {
            if (this.props.rowLink === true)
                this.props.navigate(String(row.id));
            else
                this.props.navigate(this.props.rowLink.replace(':id', row.id));
        }
        this.props.onRowClick?.(row);
    }

    clickable = () => {
        return this.props.rowLink || this.props.onRowClick;
    }

    getRow = (row, col) => {
        // TODO: add more combinations
        if(col.type === 'Dictionary`2') {
            var r = [];
            var dict = row[col.name];
            for(var k in dict) {
                if(dict[k])
                    r.push(<span className="me-2 px-1 bg-secondary text-white rounded">{k}</span>);
            }
            return r;
        }
        else if(col.type === 'DateTime')
            return Globals.toMDYHMAMPMLocalDateString(row[col.name] + 'Z', true);
        else if(col.type === 'Boolean')
            return row[col.name] ? <L>Yes</L> : <L>No</L>;
        else
            return row[col.name];
    }

    render() {
        return (
            <>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            {this.props.addons?.map((i, idx) => <th key={idx}></th>)}
                            {this.state.columns?.map((i, idx) => <th key={idx}>{i.label}</th>)}
                            {this.props.conditionals?.map((c, cdx) => <th key={cdx} className="table-conditionals"></th>)}
                            {this.props.actions && <th className="table-actions"></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list?.map((row, rowIdx) => <tr key={rowIdx} role={this.clickable() && 'button'}>
                            {this.props.addons?.map((i, idx) => <td key={idx}
                                onClick={() => this.rowClick(row)}>
                                {i.contentFunc(row)}
                            </td>)}
                            {this.state.columns?.map((col, colIdx) => <td key={colIdx}
                                onClick={() => this.rowClick(row)}>
                                {this.getRow(row, col)}
                            </td>)}
                            {this.props.conditionals?.map((c, cdx) => <td key={cdx} className="table-conditionals">
                                {c.condition(row) && c.contentFunc(row)}
                            </td>)}
                            {this.props.actions && <td className="table-actions text-end">
                                {this.props.actions.map((action, actionIdx) => (
                                    <button key={actionIdx} className={'btn btn-sm ' + (action.primary ? 'btn-primary'
                                        : action.danger ? 'btn-danger' : 'btn-secondary')}
                                        onClick={() => action.onClick(row)}>
                                        {action.label}
                                    </button>
                                ))}
                            </td>}
                        </tr>)}
                    </tbody>
                </table>
                {this.state.list?.length === 0 && <p className="text-muted"><L>There are no items.</L></p>}
            </>
        )
    }
}

export default withParamsAndNavigate(DataView);